import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'knowledgeLabel'
	| 'aboutLabel'
	| 'rovoAgentLabel'
	| 'teamsLabel'
	| 'scenariosLabel'
	| 'skillsLabel'
	| 'toolsLabel';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		knowledgeLabel: {
			id: 'rovo-chat.view-agent.knowledge-label',
			defaultMessage: 'Knowledge',
			description: 'Label for knowledge section of the agent profile',
		},
		aboutLabel: {
			id: 'rovo-chat.view-agent.about-label',
			defaultMessage: 'About',
			description: 'Label for about section of the agent',
		},
		rovoAgentLabel: {
			id: 'rovo-chat.view-agent.rovo-agent-label',
			defaultMessage: 'Rovo agent',
			description: 'The content inside About section, indicating this profile is a Rovo agent',
		},
		teamsLabel: {
			id: 'rovo-chat.view-agent.teams-label',
			defaultMessage: 'Teams',
			description: 'Label for teams section of the agent profile',
		},
		scenariosLabel: {
			id: 'rovo-chat.view-agent.scenarios-label',
			defaultMessage: 'Scenarios',
			description: 'Label for scenarios section of the agent profile',
		},
		skillsLabel: {
			id: 'rovo-chat.view-agent.skills-label',
			defaultMessage: 'Skills',
			description: 'Label for skills section of the agent profile',
		},
		toolsLabel: {
			id: 'rovo-chat.view-agent.tools-label',
			defaultMessage: 'Tools',
			description: 'Label for tools section of the agent profile',
		},
	});

export default message;
